import React, { Component } from 'react';
import {
	BrowserRouter as Router,
} from 'react-router-dom';
import './assets/styles/recsite.css';
import './App.css';
import Routes from './routes/Routes';
import IFrameService from './service/IFrameService';

class App extends Component {
	
	componentDidMount = () => {
		IFrameService.parentData();
	};
	
	render() {
		return (
			<div className="App">
				<Router>
					<Routes />
				</Router>
			</div>
		);
	}
}

export default App;





// WEBPACK FOOTER //
// ./src/App.js